import React, { useState, useEffect, useContext, useRef } from 'react'
import intl from 'react-intl-universal'
import YyFood from '../Icons/YyFood'
import Add from '../Icons/Add'
import Decrease from '../Icons/Decrease'
import { OrderCalendar } from '../Icons/OrderDrawer'
import ShoppingCar from '../Icons/ShoppingCar'
import { OrderInfoContext } from '../../contexts/OrderInfo'
import { OrderMarkContext } from '../../contexts/OrderMark'
import { OrderPriceContext } from '../../contexts/OrderPrice'
import { LanguageContext } from '../../contexts/LanguageContext'
import MyModal from '../myComponents/MyModal/MyModal'
import {
  OrderShoppingBar,
  OrderShoppingMask,
  OrdershoppingContent
} from './OrderStyle'
import {
  foodDecrease,
  foodIncrease,
  writeToCacheIface,
  updateDate,
  updatePrice,
  updateYyXgPrice,
  addFoodTestForMax
} from './OrderFunction'

export function OrderShopping (props) {
  // console.log(props.history)
  const [isshow, setIsshow] = useState(false)
  const OrderInfo = useContext(OrderInfoContext)
  const OrderMark = useContext(OrderMarkContext)
  const OrderPrice = useContext(OrderPriceContext)
  const Language = useContext(LanguageContext)
  const [showModal, setShowModal] = useState(false) // 是否显示提示信息弹窗
  const [modalInfo, setModalInfo] = useState('') // 提示信息弹窗的提示文本内容
  const [showCancelButton, setShowCancelButton] = useState(false)
  const [dateArr, setDateArr] = useState([])
  const [flag, setFlag] = useState()
  const writtenBtn = useRef('writtenBtn') // 操作dom
  // 如果缓存的营养餐和小锅菜改动了，则更新一下日期列表
  useEffect(() => {
    updateDate(OrderInfo, setDateArr)
    updatePrice(OrderInfo, OrderPrice)
    updateYyXgPrice(OrderInfo, OrderPrice)
    // console.log(OrderInfo)
  }, [OrderInfo])

  return (
    <div>
      <OrderShoppingBar className='flex h100 w100 abs zx10'>
        <li className='w77 h100 flex bg59' style={{ opacity: '0.7' }} onClick={() => setIsshow(!isshow)}>
          <div className='w20 h100 flex left-arrow-icon'>
            <div className='auto p4'><ShoppingCar /></div>
          </div>
          <div className='w80 h100 gf fw3 rel middle-text fs14'>
            <div className='mauto h18e lt2'>{intl.get('Total:')}&yen;{OrderPrice.price.toFixed(2)}</div>
          </div>
        </li>
        <li
          className='w23 h100 rel right-text'
        >
          <button id='writtenBtnid' className='abs clip' ref={writtenBtn}
            onClick={() => {
              writeToCacheIface(writtenBtn, OrderInfo, OrderMark, Language, setShowModal, setModalInfo, setShowCancelButton, props, setIsshow)
            }}
          />
          <label htmlFor='writtenBtnid' className='db h100 w100'>
            <div className='mauto tc gf h18e lt2'>{intl.get('shoppingConfirm')}</div>
          </label>
        </li>
      </OrderShoppingBar>
      <OrderShoppingMask
        className={'fixed trbl0 bg0 zx8' + (isshow ? ' ' : ' dn')}
        onClick={() => { setIsshow(!isshow) }}
      />
      <OrdershoppingContent className='fixed bgf h50 w100 zx9 trans fs14' style={{ transform: isshow ? 'translateY(2%)' : 'translateY(120%)' }}>
        <ul className='content-top h12 flex'>
          <li className='w80'>
            <span className='pl20 lt1'>{intl.get('Selected goods')}</span>
          </li>
          <li
            className='w13'
            onClick={() => {
              if (OrderInfo.cacheAllFoodList.length > 0) {
                setShowModal(true)
                setShowCancelButton(true)
                setModalInfo(intl.get('Are you sure you want to empty the list of items?'))
                setFlag('empty')
              } else {
                setShowModal(true)
                setShowCancelButton(false)
                setModalInfo(intl.get('You have not chosen any dishes yet.'))
              }
            }}>
            <span className='lt1'>{intl.get('Empty')}</span>
          </li>
        </ul>
        <ul className='h88 content-middle ova pl23 pr10 pt5'>
          {
            dateArr.length > 0 && dateArr.map((dateItem, dataIndex) => {
              return (
                <div key={dataIndex} className='mb20'>
                  <ul className={'h12 flex'}>
                    <li className='w10'><span><OrderCalendar /></span></li>
                    <li className='w35'>
                      <span>{dateItem}</span>
                    </li>
                    <li className='w55' />
                  </ul>
                  {
                    OrderMark.mealtypes.map((mealItem, mealIndex) => {
                      return (
                        <div key={mealIndex}>
                          <div className={'food-type rds5 gf h20r ml2 mt6 mb2 pl5 pr5 tc ' + (
                            OrderInfo.cacheAllFoodList.filter(item => item.dayTime && dateItem && item.dayTime.substr(0, 10) === dateItem.substr(0, 10) && mealItem.id === item.mealTypeID).length > 0 ? ' dib ' : ' dn ') +
                            (Language.locale && Language.locale.includes('en') ? ' fs12 ' : ' ')} style={{ lineHeight: '1.4285rem' }}>
                            {mealItem.mealName}
                          </div>
                          {
                            OrderInfo.cacheAllFoodList.map((itemData, foodIndex) => {
                              if (dateItem && itemData.dayTime && dateItem.substr(0, 10) === itemData.dayTime.substr(0, 10) && mealItem.id === itemData.mealTypeID) {
                                return (
                                  <ul key={foodIndex} className='flex' style={{ color: itemData.allowOrder.includes('error_limitOne') ? (itemData.selectedQuantity > 1 ? '#f31c69' : '')
                                    : (itemData.allowOrder.includes('error') && itemData.selectedQuantity > 0 ? '#f31c69' : '') }}>
                                    <li className='w65 fs13'>
                                      <div className={'ml20 vc' + (Language.locale === 'en' ? '' : ' lt1-5')} style={{overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:2,WebkitBoxOrient:'vertical',display:'-webkit-box'}}>
                                        {
                                          !itemData.isPotFood && <div className='dib mr2 mt3'><YyFood height={15} width={15} /></div>
                                        }
                                        {itemData.foodName}
                                        {itemData.allowOrder.includes('error_notInAllowDate') && itemData.selectedQuantity > 0 ? '(' + intl.get('Invalid') + ')' : ''}
                                        {itemData.allowOrder.includes('error_outToDate') && itemData.selectedQuantity > 0 ? '(' + intl.get('overdue') + ')' : ''}
                                        {itemData.allowOrder.includes('error_soldOut') && itemData.selectedQuantity > 0 ? '(' + intl.get('Sold out') + ')' : ''}
                                        {itemData.allowOrder.includes('error_Invalid') && itemData.selectedQuantity > 0 ? '(' + intl.get('Invalid') + ')' : ''}
                                        {!itemData.isPotFood && itemData.allowOrder.includes('error_alreadyOrder') && itemData.selectedQuantity > 0 ? '(' + intl.get('Duplicate') + ')' : ''}
                                        {!itemData.isPotFood && itemData.allowOrder.includes('error_limitOne') && itemData.selectedQuantity > 1 ? '(' + intl.get('Limit one') + ')' : ''}
                                        {!itemData.isPotFood && itemData.allowOrder.includes('error_patientNoOrder') && itemData.selectedQuantity > 0 ? '(' + intl.get('Invalid') + ')' : ''}
                                        {!itemData.isPotFood && itemData.allowOrder.includes('error_prepareBySelf') && itemData.selectedQuantity > 0 ? '(' + intl.get('Invalid') + ')' : ''}
                                      </div>
                                    </li>
                                    <li className='w15'>&yen;{itemData.unitPrice===0?' --':' '+ itemData.unitPrice}</li>
                                    <li className='w20 rel b3 h100'>
                                      <div
                                        className={'abs b0 h20' + (itemData.selectedQuantity <= 0 ? ' disabled' : '')}
                                        style={{ right: '3.1rem' }}
                                        onClick={() => { foodDecrease(itemData, OrderInfo) }}>
                                        {
                                          itemData.selectedQuantity === 0 ? <Decrease /> : <Decrease circleBg={'#f31c69'} />
                                        }
                                      </div>
                                      <div className='abs w23r tc r20 b2 h20'>{itemData.selectedQuantity}</div>
                                      <div
                                        className='abs r5 b0 h20'
                                        onClick={() => {
                                          setFlag('add')
                                          setShowCancelButton(false)
                                          foodIncrease(itemData, OrderInfo, setShowModal, setModalInfo, dateItem, OrderMark)
                                        }}>
                                        {
                                          addFoodTestForMax(itemData, OrderInfo, dateItem) ? <Add /> : <Add circleBg={'#f31c69'} />
                                        }
                                      </div>
                                    </li>
                                  </ul>
                                )
                              }
                            })
                          }
                        </div>
                      )
                    })
                  }
                </div>
              )
            })
          }
        </ul>
        <div style={{ height: '60px' }} className='bgf' />
      </OrdershoppingContent>
      <MyModal
        visible={showModal}
        info={modalInfo}
        cancelButtonVisible={showCancelButton}
        onOkClick={() => {
          setShowModal(false)
          if (flag === 'empty') {
            OrderInfo.setCacheAllFoodList([])
            setFlag('')
          }
        }}
        onCancelClick={() => {
          setShowModal(false)
          setFlag('')
        }}
      />
    </div>
  )
}
